import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import { type PagedState, type State } from './state.model';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  private http = inject(HttpClient);

  private readonly apiUrl = `${environment.apiBaseUrl}/state`;

  getPagedStates(page: number, size: number, active?: string, name?: string, code?: string, country?: string, sort?: string): Observable<PagedState> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('active', active !== undefined ? active : 'all');

    if (name) {
      params = params.set('name', name.trim());
    }
    if (code) {
      params = params.set('code', code.trim());
    }
    if (country) {
      params = params.set('country', country);
    }
    if (sort) {
      params = params.set('sort', sort);
    }

    return this.http.get<PagedState>(`${this.apiUrl}/find-all-paged`, { params });
  }

  createState(state: State): Observable<string> {
    const headers = new HttpHeaders().set('X-Spinner', 'true');
    return this.http.post(`${this.apiUrl}/create`, state, {
      headers,
      responseType: 'text'
    });
  }

  updateState(state: State): Observable<string> {
    const headers = new HttpHeaders().set('X-Spinner', 'true');
    return this.http.put(`${this.apiUrl}/update`, state, {
      headers,
      responseType: 'text'
    });
  }

  getStateById(stateId: string): Observable<State> {
    const headers = new HttpHeaders().set('X-Spinner', 'true');
    return this.http.get<State>(`${this.apiUrl}/get/${stateId}`, { headers });
  }

  deleteState(stateId: string): Observable<void> {
    const headers = new HttpHeaders().set('X-Spinner', 'true');
    return this.http.delete<void>(`${this.apiUrl}/hide/${stateId}`, { headers });
  }

  getStatesForDropdownByCountry(countryId: string): Observable<State[]> {
    return this.http.get<State[]>(`${this.apiUrl}/find-all-by-country-for-dropdown/${countryId}`);
  }

  getStateLabel(state: State): string {
    const name = state?.name ?? '';
    const code = state?.code ?? '';
    if (environment.showCode && name && code) {
      return `${name} (${code})`;
    }
    if (name) {
      return name;
    }
    if (code) {
      return `${code}`;
    }
    return '';
  }
}
